<div class="flex gap-2 p-2">
	<button
		class="btn-tab"
		[ngClass]="currentTab() === tabs.MAP ? 'btn-tab-active' : ''"
		(click)="currentTab.set(tabs.MAP)"
	>
		Map
	</button>
	<button
		class="btn-tab"
		[ngClass]="currentTab() === tabs.DRIVER_LIST ? 'btn-tab-active' : ''"
		(click)="currentTab.set(tabs.DRIVER_LIST)"
	>
		Driver List
	</button>
</div>
@switch (currentTab()) {
	@case (tabs.DRIVER_LIST) {
		<h2 class="text-center mb-8 text-2xl">Select drivers to follow</h2>
		<div class="flex flex-col gap-2 px-16">
			<span
				*ngFor="let driver of drivers()"
				[ngClass]="
					selectedDrivers().includes(driver.number)
						? 'bg-secondary-container'
						: 'bg-surface-container hover:bg-surface-container-high'
				"
				class="p-2 rounded"
				(click)="onDriverClick(driver)"
				>#{{ driver.number }} - {{ driver.name }}</span
			>
		</div>
	}
	@case (tabs.MAP) {
		<vb-lxp-map
			class="grow-1"
			[track]="'sebring_track.geojson'"
			[rotation]="0"
			[selectedCarIds]="selectedDrivers()"
		></vb-lxp-map>
	}
}
